import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import imgEnvironmental from '../img/sotec_img_esg_environmental.png';
import imgGovernance from '../img/sotec_img_esg_governance.png';
import imgSocial from '../img/sotec_img_esg_social.png';
import Text from '../../../common/Text.js'
import '../css/ESGManagement.css'

function ESGManagement() {
    const [Display, setDisplay] = useState('none');
    const [remainingHeight, setRemainingHeight] = useState(0);
    const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);

    };
    const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
    };


    useEffect(() => {

        // 옵션 객체
        const options = {
            // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
            root: null,
            // 타겟 요소의 30%가 루트 요소와 겹치면 콜백을 실행
            threshold: 0.3

        };

        // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                var tt = entry.target.children;
                // console.log('하위 갯수' + entry.target.children[0].target.classList.add('te'))
                if (entry.isIntersecting) {
                    entry.target.classList.add('ESG_ContentBox_active');
                    // entry.target.classList.remove('ESG_ContentBox');
                    // console.log('Add active')

                    // 지연 로딩이 실행되면 unobserve 해준다.
                    // observer.unobserve(entry.target)
                }
                else {
                    // entry.target.classList.add('ESG_ContentBox');
                    // entry.target.classList.remove('ESG_ContentBox_active');
                    // console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".ESG_ContentBox")

        ims.forEach(img =>
            observer.observe(img)
        );


        // 헤드라인
        // 옵션 객체
        const optionsHeadline = {
            // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
            root: null,
            // 타겟 요소의 30%가 루트 요소와 겹치면 콜백을 실행
            threshold: 0.3

        };

        // Intersection Observer 인스턴스
        const observerHeadline = new IntersectionObserver(function (entries, observerHeadline) {
            entries.forEach(entry => {
                var tt = entry.target.children;
                // console.log('하위 갯수' + entry.target.children[0].target.classList.add('te'))
                if (entry.isIntersecting) {
                    entry.target.classList.add('ESG_headline_active');
                    // entry.target.classList.remove('ESG_ContentBox');

                    // 지연 로딩이 실행되면 unobserve 해준다.
                    // observer.unobserve(entry.target)
                }
            })
        }, optionsHeadline)


        const imsHeadline = document.querySelectorAll(".ESG_headline")

        imsHeadline.forEach(img =>
            observerHeadline.observe(img)
        );



    }, []);





    return (
        <div>
            <div className='ESGMain'>
                <div className='ESGBody1'>
                    <Text variant='titlename' className='ESGHello'>ESG경영</Text>
                    <div className='ESGrectangle1'></div>
                </div>
                {/* <div className='ESGBody2' style={{marginBottom:'50px'}}> */}
                {/* <div><Text variant='px32w700B' style={{ color: '#0C4DA2', display: 'flex', flexdirection: 'row' }}>환경(Environmental) · 사회(Social) · 지배구조(Governance) 측면에서
                    기업의 지속 가능성과 사회적 책임을 고려한 경영 방식을 의미합니다</Text></div> */}
                {/* <div><Text variant='px32w700B' style={{color:'#0C4DA2'}}>기업의 지속 가능성과 사회적 책임을 고려한 경영 방식을 의미합니다</Text></div> */}
                {/* </div> */}

                <div class="ESG_headline">
                    <p><span class="ESG_headline_bold">환경(Environmental) · 사회(Social) · 지배구조(Governance)</span> 측면에서</p>
                    <p>기업의 지속 가능성과 사회적 책임을 고려한 경영 방식을 의미합니다.</p>
                </div>

                <div class="ESG_Container">
                    <div class="ESG_ContentBox">
                        <div class="ESG_Bg"></div>
                        <div class="ESG_ContentText">
                            <p class="ESG_Title">환경</p>
                            <div class="ESG_Content">
                                <p>친환경 제품으로 탄소 배출량 감축 환경 교육 및 인식 제고 활동</p>
                                <p>환경 교육 및 인식 제고 활동</p>
                                <p>지역 사회 환경 보호 활동 참여</p>
                                <p>미사용 전기 소등 활동</p>
                                <p>이면지 재활용 사용</p>
                            </div>
                        </div>
                    </div>

                    <div class="ESG_ContentBox">
                        <div class="ESG_Bg"></div>
                        <div class="ESG_ContentText">
                            <p class="ESG_Title">사회</p>
                            <div class="ESG_Content">
                                <p>고객 만족</p>
                                <p>지역 사회에 기부와 봉사활동</p>
                                <p>안전한 근무 환경</p>
                                <p>공정한 임금과 복리 후생</p>
                                <p>인권 존중 및 노동 조건 개선</p>
                                <p>고객 데이터 보호</p>
                            </div>
                        </div>
                    </div>

                    <div class="ESG_ContentBox">
                        <div class="ESG_Bg"></div>
                        <div class="ESG_ContentText">
                            <p class="ESG_Title">지배구조</p>
                            <div class="ESG_Content">
                                <p>투명한 재무 보고 및 감사 체계</p>
                                <p>이해관계자와 정기적인 소통</p>
                                <p>윤리적 경영 수립</p>
                                <p>위험 관리 체계 구축</p>
                                <p>내부 고발 시스템 구축</p>
                                <p>법규 준수</p>
                            </div>
                        </div>
                    </div>

                </div>


                {/* <div className='ESGBody2' style={{marginTop:'50px', flexwrap: 'wrap', flexdirection: 'row'}}>
                            <div class="ImageBox1">
                                <img class="design1"  src={imgEnvironmental}></img>
                                <Text variant="px28_ESG" className='Keyword1'>환경</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>친환경 제품으로 탄소 배출량 감축 환경 교육 및 인식 제고 활동</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>환경 교육 및 인식 제고 활동</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>지역 사회 환경 보호 활동 참여</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>미 사용 전기 소등 활동</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>이면지 재활용 사용</Text>
                            </div>

                            <div class="ImageBox2">
                                <img class="design1"  src={imgGovernance} ></img>
                                <Text variant="px28_ESG" className='Keyword1'>사회</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>고객 만족</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>지역 사회에 기부와 봉사활동</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>안전한 근무 환경</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>공정한 임금과 복리 후생</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>인권 존중 및 노동 조건 개선</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>고객 데이터 보호</Text>
                            </div>
                            <div class="ImageBox3">
                                <img class="design1"  src={imgSocial} ></img>
                                <Text variant="px28_ESG" className='Keyword1'>지배구조</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>투명한 재무 보고 및 감사 체계</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>이해관계자와 정기적인 소통</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>윤리적 경영 수립</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>리스크 관리 체계 구축</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>내부 고발 시스템 구축</Text>
                                <Text variant="px20w500" className='Keyword1Cnts'>법규 준수</Text>
                            </div>
                        </div> */}


            </div>
            {/* <div className='CEOFooter'><img src={imgCEOFooter}/></div> */}
            {/* <Footer /> */}
        </div>
    );
}

export default ESGManagement;